// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "teleop/v1/teleop.proto" (package "teleop.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Internal apis for the teleop workspace service
//
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { TeleopService } from "./teleop";
import type { UpdateWorkspaceNameResponse } from "./teleop";
import type { UpdateWorkspaceNameRequest } from "./teleop";
import type { UpdateWorkspaceLayoutResponse } from "./teleop";
import type { UpdateWorkspaceLayoutRequest } from "./teleop";
import type { DeleteWorkspaceResponse } from "./teleop";
import type { DeleteWorkspaceRequest } from "./teleop";
import type { DuplicateWorkspaceResponse } from "./teleop";
import type { DuplicateWorkspaceRequest } from "./teleop";
import type { ListWorkspacesResponse } from "./teleop";
import type { ListWorkspacesRequest } from "./teleop";
import type { GetWorkspaceResponse } from "./teleop";
import type { GetWorkspaceRequest } from "./teleop";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { CreateWorkspaceResponse } from "./teleop";
import type { CreateWorkspaceRequest } from "./teleop";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service teleop.v1.TeleopService
 */
export interface ITeleopServiceClient {
    /**
     * @generated from protobuf rpc: CreateWorkspace(teleop.v1.CreateWorkspaceRequest) returns (teleop.v1.CreateWorkspaceResponse);
     */
    createWorkspace(input: CreateWorkspaceRequest, options?: RpcOptions): UnaryCall<CreateWorkspaceRequest, CreateWorkspaceResponse>;
    /**
     * @generated from protobuf rpc: GetWorkspace(teleop.v1.GetWorkspaceRequest) returns (teleop.v1.GetWorkspaceResponse);
     */
    getWorkspace(input: GetWorkspaceRequest, options?: RpcOptions): UnaryCall<GetWorkspaceRequest, GetWorkspaceResponse>;
    /**
     * @generated from protobuf rpc: ListWorkspaces(teleop.v1.ListWorkspacesRequest) returns (teleop.v1.ListWorkspacesResponse);
     */
    listWorkspaces(input: ListWorkspacesRequest, options?: RpcOptions): UnaryCall<ListWorkspacesRequest, ListWorkspacesResponse>;
    /**
     * @generated from protobuf rpc: DuplicateWorkspace(teleop.v1.DuplicateWorkspaceRequest) returns (teleop.v1.DuplicateWorkspaceResponse);
     */
    duplicateWorkspace(input: DuplicateWorkspaceRequest, options?: RpcOptions): UnaryCall<DuplicateWorkspaceRequest, DuplicateWorkspaceResponse>;
    /**
     * @generated from protobuf rpc: DeleteWorkspace(teleop.v1.DeleteWorkspaceRequest) returns (teleop.v1.DeleteWorkspaceResponse);
     */
    deleteWorkspace(input: DeleteWorkspaceRequest, options?: RpcOptions): UnaryCall<DeleteWorkspaceRequest, DeleteWorkspaceResponse>;
    /**
     * @generated from protobuf rpc: UpdateWorkspaceLayout(teleop.v1.UpdateWorkspaceLayoutRequest) returns (teleop.v1.UpdateWorkspaceLayoutResponse);
     */
    updateWorkspaceLayout(input: UpdateWorkspaceLayoutRequest, options?: RpcOptions): UnaryCall<UpdateWorkspaceLayoutRequest, UpdateWorkspaceLayoutResponse>;
    /**
     * @generated from protobuf rpc: UpdateWorkspaceName(teleop.v1.UpdateWorkspaceNameRequest) returns (teleop.v1.UpdateWorkspaceNameResponse);
     */
    updateWorkspaceName(input: UpdateWorkspaceNameRequest, options?: RpcOptions): UnaryCall<UpdateWorkspaceNameRequest, UpdateWorkspaceNameResponse>;
}
/**
 * @generated from protobuf service teleop.v1.TeleopService
 */
export class TeleopServiceClient implements ITeleopServiceClient, ServiceInfo {
    typeName = TeleopService.typeName;
    methods = TeleopService.methods;
    options = TeleopService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: CreateWorkspace(teleop.v1.CreateWorkspaceRequest) returns (teleop.v1.CreateWorkspaceResponse);
     */
    createWorkspace(input: CreateWorkspaceRequest, options?: RpcOptions): UnaryCall<CreateWorkspaceRequest, CreateWorkspaceResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateWorkspaceRequest, CreateWorkspaceResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetWorkspace(teleop.v1.GetWorkspaceRequest) returns (teleop.v1.GetWorkspaceResponse);
     */
    getWorkspace(input: GetWorkspaceRequest, options?: RpcOptions): UnaryCall<GetWorkspaceRequest, GetWorkspaceResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetWorkspaceRequest, GetWorkspaceResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListWorkspaces(teleop.v1.ListWorkspacesRequest) returns (teleop.v1.ListWorkspacesResponse);
     */
    listWorkspaces(input: ListWorkspacesRequest, options?: RpcOptions): UnaryCall<ListWorkspacesRequest, ListWorkspacesResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListWorkspacesRequest, ListWorkspacesResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DuplicateWorkspace(teleop.v1.DuplicateWorkspaceRequest) returns (teleop.v1.DuplicateWorkspaceResponse);
     */
    duplicateWorkspace(input: DuplicateWorkspaceRequest, options?: RpcOptions): UnaryCall<DuplicateWorkspaceRequest, DuplicateWorkspaceResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<DuplicateWorkspaceRequest, DuplicateWorkspaceResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteWorkspace(teleop.v1.DeleteWorkspaceRequest) returns (teleop.v1.DeleteWorkspaceResponse);
     */
    deleteWorkspace(input: DeleteWorkspaceRequest, options?: RpcOptions): UnaryCall<DeleteWorkspaceRequest, DeleteWorkspaceResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteWorkspaceRequest, DeleteWorkspaceResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateWorkspaceLayout(teleop.v1.UpdateWorkspaceLayoutRequest) returns (teleop.v1.UpdateWorkspaceLayoutResponse);
     */
    updateWorkspaceLayout(input: UpdateWorkspaceLayoutRequest, options?: RpcOptions): UnaryCall<UpdateWorkspaceLayoutRequest, UpdateWorkspaceLayoutResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateWorkspaceLayoutRequest, UpdateWorkspaceLayoutResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateWorkspaceName(teleop.v1.UpdateWorkspaceNameRequest) returns (teleop.v1.UpdateWorkspaceNameResponse);
     */
    updateWorkspaceName(input: UpdateWorkspaceNameRequest, options?: RpcOptions): UnaryCall<UpdateWorkspaceNameRequest, UpdateWorkspaceNameResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateWorkspaceNameRequest, UpdateWorkspaceNameResponse>("unary", this._transport, method, opt, input);
    }
}
